export class ClockInForm {
  id_usuario?: number;
  pin?: string;
  id_local: number | null = null;
}
